var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view box grow"},[_c('page-headers',{staticClass:"box",attrs:{"header":'Confluera Agent Installation',"breadcrumbs":_vm.breadcrumbs,"is-border":true,"documentation":"page-installation-guide"}}),_vm._v(" "),_c('router-view',{staticClass:"full-height"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769d3a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/installation/InstallationLanding.vue
// module id = null
// module chunks = 